import {
  flatten,
} from 'lodash';

import {
  LOAD_LIMIT,
  TASK_FIELDS,
} from '../constants';
import {
  getFirstLastUserName,
} from './get-formatted-user-name';

export const loadUsersForList = (mutator, responseList) => {
  const loadUsers = (userIdsArr) => mutator.users.GET({
    params: {
      limit: LOAD_LIMIT,
      query: userIdsArr.splice(0, LOAD_LIMIT)
        .map(userId => `id==${userId}`)
        .join(' or '),
    }
  });

  const userIds = responseList.reduce((acc, record) => {
    if (record[TASK_FIELDS.ASSIGNED_USER_ID] && !acc.some((id) => id === record[TASK_FIELDS.ASSIGNED_USER_ID])) {
      acc.push(record[TASK_FIELDS.ASSIGNED_USER_ID]);
    }

    return acc;
  }, []);
  const usersPromises = [];

  while (userIds.length) {
    usersPromises.push(loadUsers(userIds));
  }

  return Promise.all(usersPromises)
    .then((userArrays) => {
      const combinedUsers = flatten(userArrays.map((arr) => arr.users));

      return responseList.map((record) => {
        if (record[TASK_FIELDS.ASSIGNED_USER_ID]) {
          const assignedUser = combinedUsers.find((user) => user.id === record[TASK_FIELDS.ASSIGNED_USER_ID]);

          if (assignedUser) {
            record[TASK_FIELDS.ASSIGNED_USER_NAME] = getFirstLastUserName(assignedUser);
          }
        }

        return record;
      });
    });
};
